export default "__VITE_ASSET__BNkRhjIi__"